import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GOOGLE_ID } from '../../constants/keys';

const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <GoogleOAuthProvider clientId={GOOGLE_ID}>{children}</GoogleOAuthProvider>;
};

export default AuthProvider;
